import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AvanceComponent } from '../../components/tarea/acciones/avance/avance.component';
import { TareaService } from '../../services/tarea.service';
import { ScnackbarData, SnackbarStyles, ToastService } from '../toast.service';
import { ParticipanteService } from '../../services/participante.service';
import { Ciudadano } from '../../models/ServidorPublico';
import { HttpErrorResponse } from '@angular/common/http';
import { Participante } from '../../models/ParticipanteType';

@Component({
    selector: 'app-dlg-add-ciudadano',
    imports: [
        MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent,
        MatButtonModule, MatIconModule,
        FormsModule, ReactiveFormsModule, MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './dlg-add-ciudadano.component.html',
    styleUrl: './dlg-add-ciudadano.component.scss'
})
export class DlgAddCiudadanoComponent {
  readonly dialogRef = inject(MatDialogRef<AvanceComponent>);
  readonly data = inject<Ciudadano>(MAT_DIALOG_DATA);
  idCiudadano: string = "-1";
  loading = false;
  comentarForm = new FormGroup({
    ciruc: new FormControl("", {
      validators: [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(10), Validators.maxLength(13)]
    }),
    nombres: new FormControl("", {
      validators: [Validators.required]
    }),
    apellidos: new FormControl("", {
      validators: [Validators.required]
    }),
    correo: new FormControl("", {
      validators: [Validators.required, Validators.email]
    }),
    telefono: new FormControl("", {
      validators: [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(10)]
    }),
    tratamientoTitulo: new FormControl("Señor/a", {
      validators: [Validators.required]
    }),
    cargo: new FormControl("Ciudadano", {
      validators: [Validators.required]
    }),
  })

  fetchingAddCiudadano = false

  snackbarData: ScnackbarData = {}

  constructor(
    private toast: ToastService,
    private participanteService: ParticipanteService
  ) {
    if (this.data) {
      this.idCiudadano = this.data.id
      this.comentarForm.controls.ciruc.setValue(this.data.ciruc)
      this.comentarForm.controls.ciruc.disable()
      this.comentarForm.controls.nombres.setValue(this.data.nombres)
      this.comentarForm.controls.apellidos.setValue(this.data.apellidos)
      this.comentarForm.controls.correo.setValue(this.data.correo)
      this.comentarForm.controls.telefono.setValue(this.data.telefono)
      this.comentarForm.controls.tratamientoTitulo.setValue(this.data.tratamientoTitulo)
      this.comentarForm.controls.cargo.setValue(this.data.cargo!)
    }
  }

  onSubmitForm() {
    this.fetchingAddCiudadano = true
    const formControls = this.comentarForm.controls
    const ciudadano: Ciudadano = {
      id: this.idCiudadano,
      ciruc: formControls.ciruc.value!,
      nombres: formControls.nombres.value!,
      apellidos: formControls.apellidos.value!,
      correo: formControls.correo.value!,
      telefono: formControls.telefono.value!,
      tratamientoTitulo: formControls.tratamientoTitulo.value!,
      cargo: formControls.cargo.value!
    }

    this.participanteService.postCiudadano(ciudadano).subscribe({
      next: (ciudadano: Ciudadano) => {
        this.snackbarData.message = "Ciudadano registrado"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingAddCiudadano = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close(this.participanteService.getParticipanteFromCiudadano(ciudadano))
      },
      error: (_) => {
        this.snackbarData.message = "Error registrando ciudadano"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingAddCiudadano = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close({ success: false })
      }
    })
  }


  buscarCiudadadano(ciruc: String): void {
    this.loading = true;
    this.participanteService.getExternalCiudadano(ciruc).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.length > 0) {
          res = res[0];
          this.comentarForm.patchValue({
            ciruc: res.ciruc,
            nombres: res.nombres,
            apellidos: res.apellidos,
            correo: res.correo,
            telefono: res.telefono,
            tratamientoTitulo: res.tratamientoTitulo,
          })
        }
      },
      error: (e: HttpErrorResponse) => {
        this.loading = false;
      }

    });
  }
  onBuscar(): void {
    this.buscarCiudadadano(this.comentarForm.controls.ciruc.value || "");
  }

  onKeydown(event: any) {
    this.buscarCiudadadano(this.comentarForm.controls.ciruc.value || "");
  }
}
